import React from "react";
import { Monitor, Smartphone, LayoutGrid } from "lucide-react";

const TechGraphic = () => {
    return (
        <div className="w-full h-full min-h-[240px] flex items-center justify-center p-4">
            <div className="relative w-full max-w-[280px] h-[220px] flex items-center justify-center">

                {/* Background ambient glow */}
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-40 h-40 bg-designColor/10 blur-[40px] rounded-full pointer-events-none" />

                {/* Desktop/Browser Window Wireframe */}
                <div className="absolute right-4 top-4 w-48 h-32 rounded-xl border border-white/20 bg-gradient-to-br from-white/10 to-transparent backdrop-blur-md shadow-2xl flex flex-col overflow-hidden">
                    {/* Browser Header */}
                    <div className="h-6 border-b border-white/10 bg-black/40 flex items-center px-2 gap-1.5 shrink-0">
                        <div className="w-1.5 h-1.5 rounded-full bg-white/30" />
                        <div className="w-1.5 h-1.5 rounded-full bg-white/30" />
                        <div className="w-1.5 h-1.5 rounded-full bg-white/30" />
                        <div className="mx-auto w-16 h-1.5 rounded-full bg-white/10" />
                    </div>
                    {/* Browser Body */}
                    <div className="flex-1 p-3 flex flex-col gap-2 relative">
                        <Monitor className="absolute right-2 bottom-2 w-12 h-12 text-white/5" strokeWidth={1} />
                        <div className="w-1/2 h-2 rounded-full bg-designColor/50" />
                        <div className="w-3/4 h-1.5 rounded-full bg-white/20 mt-1" />
                        <div className="w-2/3 h-1.5 rounded-full bg-white/20" />

                        {/* Little grid */}
                        <div className="grid grid-cols-3 gap-1.5 mt-auto">
                            <div className="h-6 rounded bg-white/10" />
                            <div className="h-6 rounded bg-white/10" />
                            <div className="h-6 rounded bg-white/10" />
                        </div>
                    </div>
                </div>

                {/* Mobile Phone Wireframe (Overlapping) */}
                <div className="absolute left-8 bottom-0 w-24 h-[140px] rounded-2xl border-2 border-white/20 bg-gradient-to-tr from-gray-900 via-[#1a1a2e] to-black backdrop-blur-xl shadow-[0_20px_40px_rgba(0,0,0,0.8)] flex flex-col items-center py-2 px-1.5 overflow-hidden z-10">
                    {/* Notch */}
                    <div className="w-8 h-1.5 rounded-full bg-white/20 mb-2 shrink-0" />

                    {/* Phone Screen Body */}
                    <div className="w-full flex-1 flex flex-col gap-1.5 relative px-1">
                        <Smartphone className="absolute right-0 bottom-4 w-10 h-10 text-white/5" strokeWidth={1} />
                        <div className="w-full h-12 rounded-lg bg-cyan-500/20 mb-1" />
                        <div className="w-3/4 h-1.5 rounded-full bg-white/30" />
                        <div className="w-1/2 h-1.5 rounded-full bg-white/20" />

                        <div className="w-full h-8 rounded-lg bg-white/10 mt-auto" />
                    </div>

                    {/* Home Indicator */}
                    <div className="w-6 h-0.5 rounded-full bg-white/30 mt-2 shrink-0" />
                </div>

                {/* Floating minimal icon connector */}
                <div className="absolute left-[85px] top-[90px] w-8 h-8 rounded-full border border-white/10 bg-black/60 backdrop-blur-md shadow-lg flex items-center justify-center z-20">
                    <LayoutGrid className="w-3.5 h-3.5 text-purple-400" />
                </div>

            </div>
        </div>
    );
};

export default TechGraphic;
